import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useDispatch } from "react-redux";

import KogInputAutoCompleteCheckControlled from "@/main/components/shared/inputAutoCompleteCheck/inputAutoCompleteCheckControlled";
import { SupplierFilterRequest } from "@/main/models/request";
import { HeadQuarterBranchFilterEnum } from "@/main/services/enum/HeadQuarterBranchFilterEnum";
import { StatusRegisterEnum } from "@/main/services/enum/StatusRegisterEnum";
import { isNullUndefined } from "@/main/services/utils";
import { getSuppliers, resetReducerSuppliers, useSupplierReducer } from "@/main/store/supplier";
import { IFormFiltersDynamicExport } from "../modalExportDynamicReport";
import { GeneralVariableType, useDynamicFiltersExport } from "./dynamicFiltersExport";

interface IVariableTypeSupplierProps extends GeneralVariableType {}
function VariableTypeSupplier({ filter }: IVariableTypeSupplierProps) {
	const dispatch = useDispatch();
	const { findFieldIndexByGuidDynamicReportVariable, idScreen, watcherCountry } = useDynamicFiltersExport();
	const { suppliers: supplierReducer } = useSupplierReducer();
	const { control, setValue } = useFormContext<IFormFiltersDynamicExport>();

	async function callSupplierApiDomain() {
		const request: SupplierFilterRequest = {
			guidCountry: String(watcherCountry?.key),
			type: HeadQuarterBranchFilterEnum.All,
			idStatusRegister: StatusRegisterEnum.Active,
		};
		dispatch(getSuppliers(request));
	}

	useEffect(() => {
		if (isNullUndefined(supplierReducer.data)) callSupplierApiDomain();

		return () => {
			dispatch(resetReducerSuppliers());
		};
	}, [JSON.stringify(watcherCountry?.key)]);

	const disabledSuppliers = isNullUndefined(supplierReducer.data) || supplierReducer.data.length === 1;
	const indexField = findFieldIndexByGuidDynamicReportVariable(filter.guidDynamicReportVariable);

	return (
		<>
			<KogInputAutoCompleteCheckControlled
				name={`filtersDinamics.${indexField}.value`}
				disableSelectAll
				control={control}
				options={supplierReducer.data || []}
				label={filter.responseServer.filterName}
				disabled={disabledSuppliers}
				isLoading={supplierReducer.isLoading}
				setValueCustom={setValue}
				controllerProps={{
					rules: { required: filter.responseServer.mandatory },
				}}
				customInputProps={{
					required: filter.responseServer.mandatory,
					id: idScreen("select-supplier"),
				}}
				onChangeCustom={() => {}}
			/>
		</>
	);
}

export default VariableTypeSupplier;
